import * as Sentry from "@sentry/remix";

// Only init Sentry when the App is running in the container, where NODE_ENV is always production
if (typeof window !== "undefined" && window?.ENV?.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://ff94e4b0032b834f49b8048b17b401e0@o150346.ingest.us.sentry.io/4510318521810944",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/remix/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    environment: window?.ENV?.ENVIRONMENT,
    denyUrls: [/https?:\/\/cdn\.amplitude\.com\/libs\/analytics-browser/i],
  });
}
